<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em;">Joe Cullen, aka ‘Bard of Dalston’, is a Liverpool-born poet and jobbing social scientist who has been living in the East End of London for the past twenty-odd years. His work has appeared in a range of poetry magazines and journals including ‘South Poetry, ’South Bank Poetry’, ‘Other Poetry’, ‘Long Poem Magazine’, ‘Decanto’, ‘The North’, ‘Stand’, ‘The Delinquent’, and ‘Footballpoets.org’.</p><br/>
<p style="text-indent:00em;">Poetry awards and commendations include: ‘Poetry Pulse’, 2012; ‘Rhyme &amp; Reason’, 2012; ‘Sportswriters Awards’, 2012; ‘Four Counties Poets’, 2015. He has given poetry readings at Torriano, London; Royal Academy of Dramatic Arts (RADA), Salisbury Arts Centre, Barbican Arts Centre, the Crystal Palace Festival and the Kentish Town Festival. He was nominated for the Forward Prize, 2011. This is his first venture into the world of prose.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?725826f9